import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import UserListTable from "../../../components/userListTable";
import QUERY from "../../../utils/service/query";

const ArchivedUserList: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1");
  const limit = parseInt(searchParams.get("limit") || "10");
  const searchQuery = searchParams.get("search") || "";
  const userTypeQuery = searchParams.get("userType") || "";
  const column = searchParams.get("column") || "createdOn";
  const order = searchParams.get("order") || "desc";

  const { data, loading, error } = useQuery(QUERY.USERS.GET_ARCHIVED_USERS, {
    fetchPolicy: "no-cache",
    variables: userTypeQuery
      ? {
          page: page,
          limit: limit,
          searchQuery: searchQuery.length > 2 ? searchQuery : "",
          userType: userTypeQuery,
          column: "createdOn",
          order: "desc",
        }
      : {
          page: page,
          limit: limit,
          searchQuery: searchQuery.length > 2 ? searchQuery : "",
          column: column,
          order: order,
        },
  });

  return (
    <>
      <Card className="">
        <Card.Header>
          <h5>Archived Users</h5>
        </Card.Header>
        <Card.Body className="bg-light">
          {loading && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
          {data?.archivedUsersList && (
            <UserListTable
              userTypeQuery={userTypeQuery}
              archived={true}
              data={data?.archivedUsersList}
              page={page}
              limit={limit}
              totalCount={data?.archivedUsersList?.totalCount || 1}
              searchQuery={searchQuery}
              statusQuery={""}
            />
          )}

          {error && <p>Something went wrong!</p>}
        </Card.Body>
      </Card>
    </>
  );
};

export default ArchivedUserList;
